import log from "loglevel";

import type {  ConfigState } from "./definitions";
import { api } from "./api";
import { storeData, getStoredData } from "./localStorage";

type LocalConfigState = Omit<ConfigState, "serverUrl"> & {
    expiration: string;
};

export const LOCAL_STORAGE_ITEM_ID = "TWILIO_WEBCHAT_WIDGET_PREFERENCES";

export const preferencesDataHandler = {
    async getRemotePreferences() {
        const cachedConfig = this.tryResumeExistingPreferences();
        if (cachedConfig) return cachedConfig;

        return this.fetchAndStoreNewPreferences();
    },

    tryResumeExistingPreferences() {
        log.debug("preferencesDataHandler: trying to refresh existing preferences");
        const storedPreferenceData = getStoredData<LocalConfigState>(LOCAL_STORAGE_ITEM_ID);

        if (!storedPreferenceData) {
            log.debug("preferencesDataHandler: no preferences stored, no preferences to refresh");
            return null;
        }

        const now = Date.now();
        const expiry = new Date(Number(storedPreferenceData.expiration)).getTime();

        if (!storedPreferenceData.expiration || now >= expiry) {
            log.debug("preferencesDataHandler: preferences expired");
            return null;
        }

        log.debug("preferencesDataHandler: existing preferences still valid, using existing preferences data");

        return storedPreferenceData;
    },

    async fetchAndStoreNewPreferences() {
        log.debug("preferencesDataHandler: fetching new preferences");

        try {
            const newPreferences = await api.contactBackend<LocalConfigState>("/preferences");
            newPreferences.expiration = `${Date.now()}`;
            log.debug("sessionDataHandler: new session successfully created");
            storeData<LocalConfigState>(LOCAL_STORAGE_ITEM_ID, newPreferences);

            return newPreferences;
        } catch (e) {
            log.error("preferencesDataHandler: error fetching new preferences", e);
            return null;
        }
    },

    clear: () => {
        localStorage.removeItem(LOCAL_STORAGE_ITEM_ID);
    }
};
